import { render, staticRenderFns } from "./SaleBanner.vue?vue&type=template&id=88168b2a&scoped=true&"
import script from "./SaleBanner.vue?vue&type=script&lang=js&"
export * from "./SaleBanner.vue?vue&type=script&lang=js&"
import style0 from "./SaleBanner.vue?vue&type=style&index=0&id=88168b2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88168b2a",
  null
  
)

export default component.exports